<template>
  <footer class="section-sm py-0">
    <div class="bg-secondary pt-5 pb-4">
      <div class="container">
        <div class="row justify-content-between">
          <div class="col-lg-4 col-md-6 col-12 mb-4">
            <div class="footer-widget">
              <h5 class="mb-4 text-primary">
                {{ $t("footer.columns.support.title") }}
              </h5>
              <ul class="list-unstyled">
                <li class="mb-2">
                  <router-link to="/accompagnement-palliatif">
                    {{ $t("footer.columns.support.items.palliative") }}
                  </router-link>
                </li>
                <li class="mb-2">
                  <router-link to="/situations-complexes-urgences">
                    {{ $t("footer.columns.support.items.complex") }}
                  </router-link>
                </li>
                <li class="mb-2">
                  <router-link to="/soins-bien-etre-socio-esthetique">
                    {{ $t("footer.columns.support.items.wellbeing") }}
                  </router-link>
                </li>
                <li class="mb-2">
                  <router-link to="/personnes-agees-troubles-cognitifs">
                    {{ $t("footer.columns.support.items.seniors") }}
                  </router-link>
                </li>
                <li class="mb-2">
                  <router-link to="/adultes-perte-autonomie-situation-handicap">
                    {{ $t("footer.columns.support.items.adults") }}
                  </router-link>
                </li>
                <li class="mb-2">
                  <router-link to="/enfants-et-adolescents">
                    {{ $t("footer.columns.support.items.kids") }}
                  </router-link>
                </li>
                <li class="mb-2">
                  <router-link to="/accompagnement-en-institutions">
                    {{ $t("footer.columns.support.items.institution") }}
                  </router-link>
                </li>
                <li class="mb-2">
                  <router-link to="/voyages-et-residences-secondaires">
                    {{ $t("footer.columns.support.items.travel") }}
                  </router-link>
                </li>
                <li class="mb-2">
                  <router-link to="/mise-au-lit-tardive">
                    {{ $t("footer.columns.support.items.bedtime") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 col-12 mb-4">
            <div class="footer-widget">
              <h5 class="mb-4 text-primary font-secondary">
                {{ $t("footer.columns.about.title") }}
              </h5>
              <ul class="list-unstyled">
                <li class="mb-2">
                  <router-link to="/qui-sommes-nous">
                    {{ $t("footer.columns.about.items.who") }}
                  </router-link>
                </li>
                <li class="mb-2">
                  <router-link to="/organisation-fonctionnement">
                    {{ $t("footer.columns.about.items.organization") }}
                  </router-link>
                </li>
                <li class="mb-2">
                  <router-link to="/approche-valeurs">
                    {{ $t("footer.columns.about.items.values") }}
                  </router-link>
                </li>
                <li class="mb-2">
                  <router-link to="/partenaires-reseau">
                    {{ $t("footer.columns.about.items.partners") }}
                  </router-link>
                </li>
                <li class="mb-2">
                  <router-link to="/zone-intervention">
                    {{ $t("footer.columns.about.items.zones") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 col-12 mb-4">
            <div class="footer-widget">
              <h5 class="mb-4 text-primary font-secondary">
                {{ $t("footer.columns.info.title") }}
              </h5>
              <ul class="list-unstyled">
                <li class="mb-2">
                  <router-link to="/galerie">
                    {{ $t("footer.columns.info.items.galleryPhotos") }}
                  </router-link>
                </li>
                <li class="mb-2 text-white">
                  {{ $t("footer.columns.info.items.tel") }}
                </li>
                <li class="mb-2 text-white">
                  <h3>
                    <span class="badge rounded-pill bg-primary">
                      {{ $t("footer.columns.info.items.availabilityBadge") }}
                    </span>
                  </h3>
                </li>
                <li class="mb-2">
                  <router-link to="/contact">
                    {{ $t("footer.columns.info.items.contact") }}
                  </router-link>
                </li>
                <li class="mb-2">
                  <router-link to="/mention-legal">
                    {{ $t("footer.columns.info.items.legal") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 col-12"></div>
        </div>

        <div class="row align-items-center mt-5 text-center text-md-start">
          <div class="col-lg-4"></div>
          <div class="col-lg-3 col-md-6 col-12 mt-4 mt-lg-0"></div>
          <div class="col-lg-3 col-md-6 col-12 text-md-end mt-4 mt-md-0"></div>
        </div>
      </div>
    </div>

    <div class="container my-3">
      <div class="row">
        <div class="col-md-2 pe-1 mt-1">
          <router-link to="/">
            <img
              loading="prelaod"
              decoding="async"
              class="img-fluid"
              width="150"
              src="@/assets/logo.png"
              :alt="$t('footer.brandAlt')"
            />
          </router-link>
        </div>
        <div class="col-md-4 mt-1">
          <span class="text-center text-body-secondary">
            {{ $t("footer.copyright.prefix") }}
            <span id="year"></span>
            {{ $t("footer.copyright.suffix") }}
          </span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      facebook: "",
      instagram: "",
    };
  },
  mounted() {
    const year = new Date().getFullYear();
    document.getElementById("year").textContent = year;
  },
};
</script>

<style></style>
